(() => {
  const mobileQuery = window.matchMedia('(max-width: 767px)');
  const addonsSelector =
    'section-store--product-addons-block[data-block-id$="__section_store_block_product_addons_rRExfA"]';
  const carouselSelector =
    'section-store--video-carousel-block[data-block-id$="__section_store_block_video_carousel_UVbRNt"]';

  const getSelectorOffColor = (addons) =>
    window.defaultProductV2AddonsSelectorOffColor || addons.settings?.switch_color || '#ffbeae';
  const getSelectorOnColor = () => window.defaultProductV2AddonsSelectorOnColor || '#31006f';

  const ensureAddonsLayoutFix = (addons) => {
    if (!addons.shadowRoot) return;

    let style = addons.shadowRoot.getElementById('default-v2-mobile-addons-layout');
    if (!style) {
      style = document.createElement('style');
      style.id = 'default-v2-mobile-addons-layout';
      addons.shadowRoot.appendChild(style);
    }

    const selectorOffColor = getSelectorOffColor(addons);
    const selectorOnColor = getSelectorOnColor();

    style.textContent = `
      .toggle .slider {
        background-color: ${selectorOffColor};
      }

      .toggle input:checked + .slider {
        background-color: ${selectorOnColor};
      }

      .toggle .slider:before {
        background-color: #fff;
      }

      .addons-box.active {
        border-color: ${selectorOnColor};
      }

      @media (max-width: 767px) {
        .addons-box {
          box-sizing: border-box;
          flex-wrap: nowrap;
          justify-content: flex-start;
          gap: 12px;
          padding-left: 12px;
          padding-right: 12px;
        }

        .product-detail {
          flex: 1 1 auto;
          width: auto;
          min-width: 0;
          justify-content: flex-start;
        }

        .product-image-link,
        .switch {
          flex: 0 0 auto;
        }

        .product-image {
          max-width: none;
        }

        .product-text {
          min-width: 0;
          padding-left: 10px;
          padding-right: 8px;
        }

        .product-title,
        .product-subtitle {
          overflow-wrap: anywhere;
          line-height: 1.25;
        }
      }
    `;
  };

  const updateMobileSizing = () => {
    document.querySelectorAll(addonsSelector).forEach((addons) => {
      const body = addons.shadowRoot?.querySelector('.body');

      if (!body) return;

      ensureAddonsLayoutFix(addons);

      const settings = addons.settings || {};
      const selectorOnColor = getSelectorOnColor();
      body.style.setProperty('--switch-color', selectorOnColor);
      body.style.setProperty('--font-size', mobileQuery.matches ? '14px' : `${settings.font_size || 12}px`);
      body.style.setProperty('--image-size', mobileQuery.matches ? '62px' : `${settings.image_size || 50}px`);
      body.style.setProperty('--switch-size', mobileQuery.matches ? '24px' : `${settings.switch_size || 22}px`);
      body.style.setProperty(
        '--item-padding-y',
        mobileQuery.matches ? '14px' : `${settings.item_padding_vertical || 12}px`
      );
    });

    document.querySelectorAll(carouselSelector).forEach((carousel) => {
      const body = carousel.shadowRoot?.querySelector('.body');

      if (!body) return;

      body.style.setProperty(
        '--grid-items',
        mobileQuery.matches ? '2' : String(carousel.settings?.grid_items || 4)
      );
    });
  };

  const initialize = () => {
    customElements.whenDefined('section-store--product-addons-block').then(() => {
      requestAnimationFrame(updateMobileSizing);
      setTimeout(updateMobileSizing, 250);
      setTimeout(updateMobileSizing, 1000);
    });

    customElements.whenDefined('section-store--video-carousel-block').then(() => {
      requestAnimationFrame(updateMobileSizing);
      setTimeout(updateMobileSizing, 250);
    });
  };

  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('shopify:section:load', initialize);
  mobileQuery.addEventListener('change', updateMobileSizing);
  new MutationObserver(updateMobileSizing).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
